import functions from "./functions.js";
import tplLoader from "./tpl-loader.js";
import pagination from "./pagination.js";
import Modal from 'bootstrap/js/dist/modal';
import Slider from "./Slider";

const list = {
    $form: null,
    form: null,
    $moreFiltersBtns: null,
    $moreFiltersBtnsIcons: null,
    moreFilters: false,
    $moreFiltersContainer: null,
    $shownItems: null,
    $total: null,
    $body: {},
    $list: null,
    list: null,
    $listWrap: null,
    $map: null,
    map: null,
    infoWindow: null,
    cluster: null,
    lastEvent: null,
    // form params
    params: {},
    defaults: {
        dateFrom: '',
        dateTo: '',
        destination: '',
        objectTypeId: '',
        guests: '2,0,0',
        personsInObject: '',
        sortBy: 0,
        _page: 1,
        perPage: 10,
        rooms: '',
        themeId: '',
        tagCategoryId: '',
        distanceBeach: '',
        distanceCenter: '',
        objectId: '',
        parking: '',
        pool: '',
        pets: '',
        grill: '',
        ac: '',
        sattv: '',
        internet: '',
        disabledPersons: '',
        washingMachine: '',
        coordinates: '',
        language: functions.getLang()
    },
    mainFields: ['dateFrom', 'dateTo', 'destination', 'objectTypeId', 'guests', 'personsInObject', 'sortBy', '_page', 'dates'],
    // set by hash change to prevent change event on form fields
    pauseChange: false,
    // hashchange and form fields change are delayed
    changeTimeout: null,
    loading: false,
    // ajax load id
    loadId: 0,
    total: null,
    // for non ajax form to reset page on normal submit
    paginated: false,
    disabledFields: {},
    locations: null,

    setLoadingMode() {
        if ( !list.loading ) {
            list.loading = true;
            if (list.$body.length) {
                list.$body.addClass('loading');
                list.$list.prepend(tplLoader);
                if (Object.keys(functions.getUrlData(true)).length !== 0) {
                    $(window).scrollTop(list.$listWrap.offset().top);
                }
                list.infoWindow && list.infoWindow.close();
               
            } else {
                list.$form
                    .find('.form-submit').prop('disabled', true)
                    .find('i').addClass('fa-spinner fa-spin fa-lg');
            }
        }
    },
    splitDates(params) {
        if(params.dates)
        {
            let val = params.dates.split(' - ');
            params.dateFrom  = val[0];
            params.dateTo    = val[1];
            params.dates = null;
        }
        else
        {
            return;
        }
        
    },
    unsetLoadingMode() {
        if ( list.loading ) {
            list.loading = false;
            list.$body.removeClass('loading').find('.list-loader').remove();
        }
    },
    getParams() {
        list.params = $.extend({}, list.defaults, functions.getUrlData(true));
    },
    setDisabledFields() {
        let disabledFields = list.$form.attr('data-disabledFields');
        if ( disabledFields ) {
            disabledFields = JSON.parse(disabledFields);
            $.map(disabledFields, (value, name) => {
                if ( list.form[name] ) {
                    list.disabledFields[name] = true;
                    list.defaults[name] = value;
                    list.form[name].disabled = true;
                    if ( name == 'dateFrom' || name == 'dateTo' ) {
                        $(list.form[name]).next().prop('disabled', true);
                    }
                }
            });
        }
    },
    onChange(e) {

        clearTimeout(list.changeTimeout);
        
        if ( list.pauseChange ) {
            return;
        }
        // if changed field is date range and not have dateFrom & dateTo prevent url push
        if ( e && e.target.name == 'dates' ) {
            let val = e.target.value.split(' - ');
            if ( val.length != 2 && val[0] != '') {
                return;
            }  
        }

        if ( e && e.target.name == 'destination') {
            if(list.params.destination == '' && list.params.coordinates != '') {
                list.params.coordinates = ''; 
            }
        }

        if( e && list.mainFields.indexOf(e.target.name) === -1)
        {
            return;
        }
        // not advanced (ajax) search
        if ( !list.$body.length ) {
            return;
        }

        list.changeTimeout = setTimeout(() => {
            functions.setUrlData(list.getFormData(), list.$body.length);
        }, 300);
    },
    getFormData() {
        let formData = $.extend(
            functions.getFormData(list.$form), {
                coordinates: list.params.coordinates,
                _page: list.paginated ? list.params._page : 1,
                sortBy: list.paginated ? list.params.sortBy : 0
            }
        );
        list.paginated = false;
        // do not send same values as defaults
        $.map(formData, (val, key) => {
            if ( list.defaults[key] == val ) {
                delete formData[key];
            }
        });
        return formData;
    },
    init() {
        list.$form = $('.search-form');
        if( ! list.$form.length ) return;

        list.$body = $('#list');
        list.$total = $(".showingTotal");
        list.form = list.$form[0]

        list.getParams();

        functions.setFormData(list.form, list.params);
        list.find();

        // register form fields changes
        //list.$form.on('change', list.onChange);

        list.$form.on('submit', e => {
            e.preventDefault();
            if ( list.$body.length ) {
                list.onChange();
            } else {
                // non ajax form
                let data = $.param(list.getFormData()),
                toHash = true;
                let href = location.protocol + '//' + location.host + list.$form.attr('action');
                if ( data ) {
                    href += (href.indexOf('?') === -1 ? (toHash ? '#' : '?') : '&');
                }
                href += data;
                list.setLoadingMode();
                location.href = href;
            }
        });
        // register hashchange which trigger load
        $(window).on('hashchange', () => {
            list.pauseChange = true;
            clearTimeout(list.changeTimeout);
            list.changeTimeout = setTimeout(() => {
                list.getParams();
                functions.setFormData(list.form, list.params);
                list.markers && list.clearMarkers();
                list.find();
                list.params.coordinates && $(list.form.destination).next().find('.select2-selection__placeholder').text("Area on map");
                list.pauseChange = false;
            }, 100);
        });
        $('[name="sortBy"]').on('change', e => {
            list.params._page = 1;
            list.params.sortBy = $(e.target).val();
            if ( list.$body.length ) {
                functions.setUrlData(list.params, true);
            } else {
                list.paginated = true;
                list.$form.submit();
            }
        });

        $('.clear-filters').on('click', e => {
            let changed = false;
            let formData = {}

            $.map(list.params, (value, key) => {
                if ( list.mainFields.indexOf(key) === -1 ) {
                    if ( list.params[key] && list.params[key] != list.defaults[key] ) {
                        changed = true;
                    }
                    formData[key] = list.defaults[key];
                }
            });
            functions.setFormData(list.form, formData);
            if ( changed ) {
                if ( ! e.target.classList.contains('clear-filters-mobile') ) {
                    list.onChange();
                }
                if ( !list.$body.length ) {
                    list.$form.submit();
                }
            }
        });

        // register paginate        
        $(document).on('click', '.pagination a[data-page]', e => {
            e.preventDefault();
            list.paginate(+$(e.currentTarget).attr('data-page'));
        });
    },
    paginate(page) {
        if ( page != list.params._page ) {
            list.params._page = page;
        }
        if ( list.$body.length ) {
            functions.setUrlData(list.params, list.$body.length);
        } else {
            list.paginated = true;
            list.$form.submit();
        }
    },
    find() {
        // init list
        if ( ! list.$list ) {
            list.$list = $('.list');
            list.$pagination = $('.list-pagination');
            list.list = list.$list[0];
            list.$listWrap = list.$list.closest('.list-wrap');
            list.unsetLoadingMode();
        }
        list.setLoadingMode();
        let ajaxId = ++list.loadId;
        list.splitDates(list.params);
        $.get('/services/list', list.params).then(response => {
            if ( ajaxId !== list.loadId ) {
                return;
            }
            response = JSON.parse(response);

            list.total = response.total;
            list.$list[0].innerHTML = response.html;
            list.$pagination[0].innerHTML = pagination({
                perPage: list.params.perPage,
                currentPage: list.params._page,
                total: list.total
            })

            list.$total.html(list.total);

            list.domInits();
            list.unsetLoadingMode();
        });
    },
    domInits() {

        let listSlider = [];
        $('[id^=list-slider]').each((i, elem) => {
            const length = $(elem).find('.keen-slider__slide').length;
            listSlider[i] = new Slider(elem, {
                fade: true,
                loop: true,
                arrows: true,
                slides: {
                    perView: 1,
                },
            });
        });

        let $dropdown = $(".dropdown-sort-by");
        $dropdown.find('.dropdown-item').on('click', function (e) {
            e.preventDefault();
            list.params._page = 1;
            list.params.sortBy = $(e.currentTarget).attr('href');
            $dropdown.find('.dropdown-toggle').removeClass('show');
            $dropdown.find('.dropdown-menu').removeClass('show');
            if ( list.$body.length ) {
                functions.setUrlData(list.params, true);
            } else {
                list.paginated = true;
                list.$form.submit();
            }
        });

        if (list.params.sortBy) {
            let text = $dropdown.find(".dropdown-item[href='"+list.params.sortBy+"']").html();
            $dropdown.find(".btn").html(text);
        }

        observer.observe();

        $('.details-discount').on('click', e => {
            e.preventDefault();
            const $this = $(e.target);
            window.open($this.attr('data-href'), '_blank');
        });
    },
    closeModal()
    {
        var modal = Modal.getInstance($('#filtersModal'));
        modal.hide();
        $('.modal-backdrop').remove();
    }
    
};

$(() => {
    list.init();
    //list.loadMap();
})